import { render } from "./InstructorTwoPage.vue?vue&type=template&id=6283de47&ts=true"
import script from "./InstructorTwoPage.vue?vue&type=script&lang=ts"
export * from "./InstructorTwoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__